import MainLayout from "../../layouts/main";
import styled from "styled-components";
import useSWR from "swr";
import {
  Grid,
  Breadcrumb,
  Text,
  Flex,
  Box,
  NewsInfo,
  Pagination,
} from "../../components";
import useBreakpoint from "../../hooks/useBreakpoint";
import Heading from "../../components/Heading";
import Image from "next/image";
import { useRouter } from "next/router";
import { useMemo } from "react";
import dayjs from "dayjs";

const StyledWrapper = styled("div")`
  padding-top: 140px;
  min-height: 100vh;
`;

const StyledContainer = styled("div")`
  margin: 0 auto;
  max-width: 1440px;
  width: 90%;
`;

const StyledCard = styled(Flex)`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  :hover {
    transform: scale(1.1);
  }
`;

const StyledGrid = styled(Grid)`
  ${({ theme }) => theme.mediaQueries.sm} {
    grid-template-columns: 1fr 1fr;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

const StyledHeading = styled(Heading)`
  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 36px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    font-size: 100px;
    line-height: 97px;
  }
`;

const NewsPage = () => {
  const router = useRouter();
  const page = router?.query?.page || 1;
  const { data } = useSWR<NewsResponse>(`/v1/news?page=${page}&size=10`);

  const news = (data && data.data) || [];
  const filteredNews = useMemo(() => {
    // Filter the news array based on the start_date and end_date conditions
    return news.filter((item) => {
      const startDate = dayjs(item.start_date);
      const endDate = dayjs(item.end_date);
      const currentDate = dayjs();
      return (
        startDate.isBefore(currentDate, "day") &&
        endDate.isAfter(currentDate, "day")
      );
    });
  }, [news]);
  const pageMetaData = data && data.page_metadata;

  const handlePageChange = (selectedItem: { selected: number }) => {
    const page = selectedItem.selected + 1;
    if (page === 1) {
      router.push("/events");
    } else {
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page },
      });
    }
  };

  const items = [
    { title: "Home", link: "/" },
    { title: "News", link: "/news" },
  ];
  return (
    <MainLayout bg="/images/news-bg.webp">
      <StyledWrapper>
        <StyledContainer>
          <Breadcrumb items={items} current="News" />
          <StyledHeading mt="63px" fontWeight="900">
            NEWS
          </StyledHeading>

          <StyledGrid mt="90px" style={{ gap: "40px" }}>
            {filteredNews?.map((item, index) => (
              <NewsInfo key={item.id} item={item} index={index} />
            ))}
          </StyledGrid>
          <Pagination
            previousLabel={"<"}
            nextLabel={">"}
            pageCount={pageMetaData?.total_pages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={handlePageChange}
          />
        </StyledContainer>
      </StyledWrapper>
    </MainLayout>
  );
};

export default NewsPage;
